import script from "./TheAdminCalllist.vue?vue&type=script&setup=true&lang=js"
export * from "./TheAdminCalllist.vue?vue&type=script&setup=true&lang=js"

import "./TheAdminCalllist.vue?vue&type=style&index=0&id=5845fc76&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5845fc76"]])

export default __exports__